import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button, Icon, Input } from '@aqarmap/aqarmap-ui';
import { EvaluationSteps } from '~valuation/enums';
import Tooltip from '~/components/Tooltip';

const EstimatedPriceEntryStep = ({
  setActiveStep,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation('app');
  const { setValue, watch } = useFormContext();
  const priceValue = watch('expectedValuationPrice') || '';

  const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const num = e.target.value.split(',').join('');
    if (num === '') {
      setValue('expectedValuationPrice', '');
      return;
    }
    if (/^\d*$/.test(num)) {
      setValue('expectedValuationPrice', Number(num));
    }
  };

  const handleNext = async () => {
    setActiveStep(EvaluationSteps.DATA_ANALYSIS);
  };

  return (
    <div className="flex flex-col gap-3x md:gap-5x">
      <div className="flex flex-col gap-2x px-2x md:px-0">
        <div className="flex gap-x items-center">
          <p className="text-lg text-title_4 text-black">
            {t('purchaseEnterEstimate')}{' '}
          </p>
          <Tooltip
            className="max-w-[272px]"
            id="expectedValuationPrice"
            text={t('expectedValuationPriceTooltipText') ?? ''}
          >
            <Icon name="info" size="16px" className="text-blue_dark_1" />
          </Tooltip>
        </div>
        <div className="flex gap-1.5x rounded-[12px] border border-[#E0E0E0] h-[40px] px-1.5x py-x focus-within:border-blue_light_1 transition-all">
          <Input
            field={{
              type: 'text',
              placeholder: t('purchaseEnterEstimatePlaceholder'),
              value: priceValue ? Number(priceValue).toLocaleString() : '',
              onChange: handlePriceChange,
              className:
                'text-body_2 text-gray__dark_2 placeholder:text-gray__dark_1 flex-1 w-[60px] !px-[1px]',
            }}
            className="[&>div]:!px-0 [&>div]:!border-none [&>div]:!focus-within:!border-none &>div]:!rounded-none"
          />
          <p className="h-[24px] ps-x border-s border-gray text-body_2 text-gray__dark_2 whitespace-nowrap">
            {t('egyptianPound')}
          </p>
        </div>
      </div>

      <div className="flex justify-center pt-3x px-2x md:px-3x border-t border-gray w-full gap-1.5x md:gap-5x">
        <Button
          variant="primary"
          size="medium"
          className="text-link w-full max-w-[271px] whitespace-nowrap"
          onClick={() => handleNext()}
        >
          {t('finalCalculate')}
        </Button>
        <Button
          variant="secondary"
          size="medium"
          className="text-link w-full max-w-[271px]"
          onClick={() => setActiveStep(EvaluationSteps.PROPERTY_PRICE)}
        >
          {t('back')}
        </Button>
      </div>
    </div>
  );
};

export default EstimatedPriceEntryStep;
